/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["kea",[["am","pm"],u,u],u,[["D","S","T","K","K","S","S"],["dum","sig","ter","kua","kin","ses","sab"],["dumingu","sigunda-fera","tersa-fera","kuarta-fera","kinta-fera","sesta-fera","sábadu"],["du","si","te","ku","ki","se","sa"]],u,[["J","F","M","A","M","J","J","A","S","O","N","D"],["Jan","Feb","Mar","Abr","Mai","Jun","Jul","Ago","Set","Otu","Nuv","Diz"],["Janeru","Febreru","Marsu","Abril","Maiu","Junhu","Julhu","Agostu","Setenbru","Otubru","Nuvenbru","Dizenbru"]],u,[["AK","DK"],u,["antis di Kristu","dispos di Kristu"]],1,[6,0],["dd/MM/y","d MMM y","d 'di' MMMM 'di' y","EEEE, d 'di' MMMM 'di' y"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1}, {0}",u,u,u],[","," ",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","#,##0.00 ¤","#E0"],"CVE","​","Skudu Kabuverdianu",{"AUD":["AU$","$"],"CVE":["​"],"JPY":["JP¥","¥"],"THB":["฿"],"USD":["US$","$"]},"ltr", plural];
